import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useMemo } from 'react';
import { Button } from '../../Button/Button.js';
import { Icon } from '../../Icon/Icon.js';

function ContentOnlyHeaderTemplate(props, panelRef) {
  var _a;
  const [isCollapsed, setCollapsed] = useState((_a = props.collapsed) !== null && _a !== void 0 ? _a : false);
  const buttonClass = useMemo(() => {
    if (isCollapsed) return 'active';
    return '';
  }, [isCollapsed]);
  const buttonIcon = useMemo(() => {
    if (isCollapsed) return 'keyboard_arrow_down';
    return 'keyboard_arrow_up';
  }, [isCollapsed]);
  const buttonText = useMemo(() => {
    if (isCollapsed) return 'Show';
    return 'Hide';
  }, [isCollapsed]);
  return jsxs("div", {
    className: "flex justify-content-between p-panel-header",
    children: [jsx("h4", {
      children: props.header
    }), jsx(Button, {
      tertiary: true,
      label: buttonText,
      className: buttonClass,
      icon: jsx(Icon, {
        name: buttonIcon
      }),
      iconPos: "right",
      onClick: () => {
        var _a;
        setCollapsed(!isCollapsed);
        (_a = panelRef.current) === null || _a === void 0 ? void 0 : _a.toggle(undefined);
      },
      style: {
        minWidth: '77px'
      }
    })]
  });
}

export { ContentOnlyHeaderTemplate };
